module.exports = __webpack_public_path__ + "img/loading.5fe0e55f.gif";